import api from "@/services/api/sightings";

const state = {
  isDialogOpen: false,
  sightings: [],
};

const getters = {
  dialog: (state) => state.isDialogOpen,
  sightings: (state) => state.sightings,
};

const actions = {
  async open({ commit }) {
    commit("sightings/setMessage", "", { root: true });
    const result = await api.allSightings();
    commit("setSightings", result.data);
    commit("open");
  },
  close({ commit }) {
    commit("close");
  },
};

const mutations = {
  open(state) {
    state.isDialogOpen = true;
  },
  close(state) {
    state.isDialogOpen = false;
    state.sightings = [];
  },
  setSightings(state, sightings) {
    state.sightings = sightings;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
